import { useEffect, useState } from "react";

import { addWeeks, currentMonday } from "@/client/pages/plan/types";

/**
 * Manages week navigation state: target date, URL sync, and navigation helpers.
 */
export function useWeekNavigation(initialStartDate?: string) {
  const [targetDate, setTargetDate] = useState(initialStartDate ?? "");

  const monday = currentMonday();
  const displayStartDate = targetDate || monday;
  const isCurrentWeek = displayStartDate === monday;

  useEffect(() => {
    const url = isCurrentWeek ? "/plan" : `/plan/${displayStartDate}`;
    window.history.replaceState(null, "", url);
  }, [displayStartDate, isCurrentWeek]);

  function navigateWeek(offset: number) {
    setTargetDate(addWeeks(displayStartDate, offset));
  }

  function goToCurrentWeek() {
    setTargetDate("");
  }

  /** Select a specific week start date (resets to current if it matches this Monday). */
  function selectWeek(startDate: string) {
    setTargetDate(startDate === monday ? "" : startDate);
  }

  return {
    targetDate,
    displayStartDate,
    isCurrentWeek,
    navigateWeek,
    goToCurrentWeek,
    selectWeek,
  };
}
